import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=24ed5dda&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=ts"
export * from "./ContactUs.vue?vue&type=script&lang=ts"
import style0 from "./ContactUs.vue?vue&type=style&index=0&id=24ed5dda&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ed5dda",
  null
  
)

export default component.exports